<template>
  <div class="">
    <mNav></mNav>
    <mBanner></mBanner>

    <div class="detail_head">
      <div class="detail_head_container">
        <div class="detail_title">
          {{ detail.newsname }}
        </div>
        <div class="detail_info">
          <img class="icon_time" src="@/assets/imgs/time.png" alt="date" />
          <span>{{ detail.time }}</span>
          <img class="icon_view" src="@/assets/imgs/view.png" alt="view" />
          <span>{{ detail.views }}</span>
        </div>
      </div>
    </div>
    <div class="detail_text">
      <div class="detail_text_container">
        <div class="show_text"  v-html="detail.content">
        </div>
      </div>
    </div>
    <mFooter></mFooter>
  </div>
</template>
    <script>
import mNav from "@/components/m/Nav";
import mBanner from "@/components/m/Banner";
import mFooter from "@/components/m/Footer";
export default {
  name: "mIndex",
  components: {
    mNav,
    mBanner,
    mFooter,
  },
  metaInfo: {
    title: "洋宇集团",
    meta: [
      {
        name: "viewport",
        content:
          "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=yes",
      },
    ],
  },
  data() {
    return {
      detail: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .get(
          this.$host + "/api/news/detail?id=" + this.$route.params.id
        )
        .then((res) => {
          this.detail = res.data.data;
          console.log(this.detail);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
  <style scoped>
.detail_head {
  width: 100%;
}
.detail_head .detail_head_container {
  padding: 20px 20px 15px 20px;
  border-bottom: 1px solid #f3f3f3;
}
.detail_head .detail_title {
  font-size: 0.22rem;
  font-weight: 600;
  color: #000000;
  line-height: 0.28rem;
  margin-bottom: 15px;
}

.detail_head .detail_info {
  font-size: 10px;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
}

.detail_head .detail_info img {
  vertical-align: unset;
}

.detail_head .detail_info .icon_time {
  width: 13px;
  height: 13px;
}

.detail_head .detail_info .icon_view {
  width: 15px;
  height: 10px;
  margin-left: 14px;
}

.detail_head .detail_info span {
  line-height: 15px;
  font-size: 0.15rem;
}

.detail_text img {
  width: 100%;
}

.detail_text p {
  font-size: 22px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
}
.detail_text .detail_text_container {
  padding: 0.2rem 0.15rem 0.3rem 0.15rem;
}

.detail_text .show_text {
  font-size: 0.2rem;
  line-height: 0.28rem;
}
</style>


// WEBPACK FOOTER //
// src/page/m/Detail.vue